import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a4379aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "material-shaped-button",
  href: "#"
}

import MaterialShapeContainer from './../material-shape-container.vue';
import { IMaterialShapedButtonProps } from './material-shaped-button.types';
import googleMaterialIcon from './../../google-material-icon/google-material-icon.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'material-shaped-button',
  props: {
    props: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", _hoisted_1, [
    _createVNode(MaterialShapeContainer, {
      props: {
                shape: 'four-pointed-shape',
                strokeWidth: 15,
            },
      class: "material-shaped-button__container"
    }, {
      default: _withCtx(() => [
        _createVNode(googleMaterialIcon, {
          class: "material-shaped-button__icon",
          props: {
                    iconName: __props.props.icon,
                }
        }, null, 8, ["props"])
      ]),
      _: 1
    })
  ]))
}
}

})